import { msg } from '@lingui/core/macro';

import { defineFilters } from '@/shared/filters/define-filters';
import { decimalToCents, parseMoneyInput } from '@/shared/format/money';

import { OPERATOR_STATUS_OPTIONS } from './bank-account-tabs.filters';

// Filtros da aba Pagamentos (U4a). Leve: entra no `validateSearch` da rota do detalhe. A chave da URL é própria da
// aba (`pay_*`): o fio usa `searchString` e `f_status`, como as outras abas.

/**
 * `f_paymentDate` (`filterContext.tsx:131-133,144-146`): o `DatePickerFormField` grava o dia à meia-noite com
 * `-03:00` fixo (`DateFormat.ts:218-232`), o filtro de tipo `date` o volta a `Date` e a URL leva `toISOString()`.
 */
export const paymentDateFilterParam = (day: string) => new Date(`${day}T00:00:00.000-03:00`).toISOString();

/**
 * `f_amount` (`BankAccountFilters.tsx:321-329`): o `CurrencyFormField` grava centavos. Texto que não é valor, ou
 * zero (o `addFilter` do legado descarta valor falso), não vai ao fio.
 */
export function paymentAmountFilterParam(raw: string): string | undefined {
  const decimal = parseMoneyInput(raw);
  if (decimal === null) return undefined;
  const cents = decimalToCents(decimal);
  return cents === 0 ? undefined : String(cents);
}

/** `availableFilters` da aba (`PaymentListContainer.tsx:81-91`), na ordem do "Filtrar por" (`BankAccountFilters.tsx:89-94`). */
export const paymentListFilters = defineFilters([
  { key: 'pay_searchString', param: 'searchString', type: 'search', label: msg`Todos`, placeholder: msg`Filtrar por todos` },
  { key: 'pay_status', param: 'f_status', type: 'select', label: msg`Status`, options: OPERATOR_STATUS_OPTIONS },
  { key: 'pay_paymentDate', param: 'f_paymentDate', type: 'date', label: msg`Data do pagamento`, placeholder: msg`Filtrar por data do pagamento`, toParam: paymentDateFilterParam },
  { key: 'pay_amount', param: 'f_amount', type: 'text', label: msg`Valor do pagamento`, placeholder: msg`Filtrar por valor do pagamento`, toParam: paymentAmountFilterParam },
]);
